import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Fuel, Building2, GraduationCap, Camera, FileText } from "lucide-react";
import Logo from "../../components/Logo";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ fuel: null, hangars: 0, schools: 0, photos: 0, reports: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/fuel-prices"),
      api.get("/hangars"),
      api.get("/flight-schools"),
      api.get("/photos"),
      api.get("/reports"),
    ]).then(([f, h, s, p, r]) =>
      setStats({ fuel: f.data, hangars: h.data.length, schools: s.data.length, photos: p.data.length, reports: r.data.length })
    );
  }, []);

  const cards = [
    { icon: Fuel, label: "100LL", value: stats.fuel ? `$${stats.fuel.avgas_100ll.toFixed(2)}` : "—" },
    { icon: Fuel, label: "Jet-A w/ Prist", value: stats.fuel ? `$${stats.fuel.jet_a_with_prist.toFixed(2)}` : "—" },
    { icon: Building2, label: "Hangars", value: stats.hangars },
    { icon: GraduationCap, label: "Flight Schools", value: stats.schools },
    { icon: Camera, label: "Photos", value: stats.photos },
    { icon: FileText, label: "Reports", value: stats.reports },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-center justify-between gap-6 flex-wrap">
        <div>
          <div className="section-label">Overview</div>
          <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Dashboard</h1>
        </div>
        <Logo size="xl" />
      </div>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map(({ icon: Icon, label, value }) => (
          <div key={label} className="bg-white border border-slate-200 p-6 rounded-md">
            <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-sky-600">
              <Icon className="h-4 w-4" /> {label}
            </div>
            <div className="font-display text-4xl font-bold mt-2 text-slate-950">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
